module.exports = __webpack_public_path__ + "static/img/11-2.21d09c4f.jpg";